<template>
    <div>
        <div class="page bg-white" style="padding-bottom: 120px">
            <div v-for="(elem,index) in orderList" :key="index">
                <van-divider v-if="index>0"/>
                <van-cell-group>
                    <van-cell :value="`订单编号#${index+1}`" :border="false" />
                    <van-field
                            readonly
                            clickable
                            label="客服"
                            :value="elem.kfName"
                            placeholder="选择客服"
                            @click="selectKf(index)"
                            :border="false"
                    />
                    <van-cell title="时长" :border="false">
                        <van-stepper v-model="elem.duration" :min="0.5"/>
                    </van-cell>
                    <van-field v-model="elem.hourWage" label="单价" type="number" input-align="right" :border="false"/>
                    <van-cell title="总单价" :value="elem.duration * elem.hourWage" :border="false"/>
                    <van-field v-model="elem.note" rows="2" maxlength="100" autosize label="备注" type="textarea"
                               placeholder="请输入备注（选填）" :border="false"/>
                </van-cell-group>
                <div style="display: flex;justify-content: center" v-if="orderList.length>1">
                    <van-button round style="padding: 0 50px" type="danger" @click="removeOrder(index)">删除
                    </van-button>
                </div>
            </div>
        </div>
        <div style="position: fixed;bottom: 0;left:0;width: 100%;box-sizing: border-box;">
            <div style="padding: 10px;background: #f8f8f8">合计：{{orderList.length}}条订单，总单价￥{{sumTotalWage}}</div>
            <div style="display: flex;align-items: center;background: white;padding: 10px">
                <van-button round size="large" style="margin: 0 20px" type="info" @click="addOrder">新增</van-button>
                <van-button round size="large" style="margin: 0 20px" type="primary" @click="submitClick">提交</van-button>
            </div>

        </div>
        <!-- 选择客服 -->
        <van-popup
                v-model="kfPickerVisible"
                class="datetime-picker-popup"
                position="bottom"
        >
            <van-picker
                    title="客服"
                    show-toolbar
                    :columns="kfList"
                    @confirm="onSelectKfConfirm"
                    @cancel="kfPickerVisible = false"
            />
        </van-popup>


    </div>
</template>

<script>
import Vue from 'vue';
import {Divider} from 'vant';

import {
    Cell,
    CellGroup,
    Popup,
    Search,
    Checkbox,
    CheckboxGroup,
    RadioGroup,
    Radio,
    Field,
    Button,
    Picker,
    Dialog,
    Stepper,
    Toast
} from 'vant';
import Decimal from "decimal.js";
import {handlePromise} from "@/libs/util";
import {getUploadOrderOptions, uploadOrder, uploadOutDispatchOrder} from "@/api/clerk/dispatchOrder";
import _ from 'lodash'

Vue.use(Cell)
    .use(CellGroup)
    .use(Popup)
    .use(Search)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(RadioGroup)
    .use(Radio)
    .use(Field)
    .use(Button)
    .use(Picker)
    .use(Toast)
    .use(Stepper)
    .use(Divider)

export default {
    name: 'out-order-upload',
    data() {
        return {
            curOrderIndex: null,
            kfPickerVisible: false,
            kfName: null,
            kfMap: null,
            kfList: null,
            orderList: [
                {
                    kfName: null,
                    kfId: null,
                    duration: 1,
                    note: null,
                    hourWage: null,
                }
            ]
        }
    },
    computed: {
        sumTotalWage(){
            let sum = 0;
            this.orderList.forEach(elem=>{
                sum+=elem.duration * elem.hourWage
            })
            return sum
        }
    },
    methods: {
        addOrder() {
            this.orderList.push({
                kfName: null,
                kfId: null,
                duration: 1,
                note: null,
                hourWage: null,
            })
        },
        removeOrder(index) {
            Dialog.confirm({title: '确定要删除该订单吗？'}).then((action)=>{
                if(action === 'confirm'){
                    this.orderList.splice(index, 1)
                }
            })
        },
        selectKf(index) {
            this.curOrderIndex = index
            this.kfPickerVisible = true
        },
        loadData() {
            Toast.loading({
                mask: true,
                message: '加载中...'
            })
            handlePromise(getUploadOrderOptions(), (data) => {
                this.kfMap = new Map()
                this.kfList = []
                for (let kf of data.kfList) {
                    this.kfMap.set(kf.name, kf.id)
                    this.kfList.push(kf.name)
                }
                Toast.clear()
            })
        },
        onSelectKfConfirm(val) {
            this.orderList[this.curOrderIndex].kfName = val
            this.orderList[this.curOrderIndex].kfId = this.kfMap.get(val)
            this.kfPickerVisible = false
        },
        formatPrice(price) {
            if (price != null) {
                return Decimal.div(price, 100).toString()
            }
            return ''
        },
        submitClick() {
            let count = 0;
            let orderList = JSON.parse(JSON.stringify(this.orderList))
            _.forEach(orderList,(elem, index)=>{
                if (elem.kfId === null) {
                    Toast(`订单编号#${index+1} 未选择客服`)
                    return false
                }
                if (!elem.duration) {
                    Toast(`订单编号#${index+1} 未输入时长`)
                    return false
                }
                if(!elem.hourWage){
                    Toast(`订单编号#${index+1} 未输入单价`)
                    return false
                }
                elem.hourWage = Decimal.mul(elem.hourWage,100)
                count++
            })
            if(count!== orderList.length){
                return
            }
            Toast.loading({
                mask: true,
                message: '加载中...'
            })
            uploadOutDispatchOrder(
                JSON.stringify(orderList)
            ).then(res => {
                Toast.clear()
                const data = res.data
                if (data.code === 0) {
                    Dialog.alert({
                        title: '提示',
                        message: '提交成功'
                    }).then(() => {
                        this.$router.push('/clerk/dispatchOrder/list')
                        this.reset()
                    })
                } else {
                    Dialog.alert({
                        title: '提交失败',
                        message: data.msg
                    })
                }
            })
        },
        reset() {
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>

<style lang="less" scoped>
.page {
  padding: 15px;
}

.cellBox {
  margin: 10px 0;
}

.flexStyle {
  display: flex;
  padding: 10px 16px;
}

.title {
  -webkit-box-flex: 0;
  width: 6.2em;
  color: #646566;
  flex: none;
  margin-right: 12px;
  box-sizing: border-box;
  word-wrap: break-word;
}

.notSelected {
  margin: 0 5px 5px 0;
  padding: 5px;
  border-radius: 5px;
  background: #f5f5f5;
}

.selected {
  margin: 0 5px 5px 0;
  padding: 5px;
  border-radius: 5px;
  background: #07c160;
  color: #fff;
}

.clerkBox {
  border-bottom: 1px #f5f5f5 solid;
  padding: 15px;
}

/deep/ .van-hairline--top-bottom:after {
  border: none;
}

/deep/ .van-field__control {
  background: #f5f5f5;
  padding: 5px;
  border-radius: 5px;
}

/deep/ .van-radio {
  margin-bottom: 5px;
}
</style>
